'use strict';
import * as $j_com$002eraquo$002elaminar$002ekeys$002e$002dEvent$002dProp from "./com.raquo.laminar.keys.-Event-Prop.js";
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
var $p;
/** @constructor */
function $c_Lbe_doeraene_webcomponents_ui5_Select$events$() {
  this.Dd = null;
  $n_Lbe_doeraene_webcomponents_ui5_Select$events$ = this;
  this.Dd = new $j_com$002eraquo$002elaminar$002ekeys$002e$002dEvent$002dProp.$c_Lcom_raquo_laminar_keys_EventProp("change");
}
export { $c_Lbe_doeraene_webcomponents_ui5_Select$events$ as $c_Lbe_doeraene_webcomponents_ui5_Select$events$ };
$p = $c_Lbe_doeraene_webcomponents_ui5_Select$events$.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Lbe_doeraene_webcomponents_ui5_Select$events$;
/** @constructor */
function $h_Lbe_doeraene_webcomponents_ui5_Select$events$() {
}
export { $h_Lbe_doeraene_webcomponents_ui5_Select$events$ as $h_Lbe_doeraene_webcomponents_ui5_Select$events$ };
$h_Lbe_doeraene_webcomponents_ui5_Select$events$.prototype = $p;
var $d_Lbe_doeraene_webcomponents_ui5_Select$events$ = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Lbe_doeraene_webcomponents_ui5_Select$events$, "be.doeraene.webcomponents.ui5.Select$events$", ({
  gm: 1
}));
export { $d_Lbe_doeraene_webcomponents_ui5_Select$events$ as $d_Lbe_doeraene_webcomponents_ui5_Select$events$ };
var $n_Lbe_doeraene_webcomponents_ui5_Select$events$;
function $m_Lbe_doeraene_webcomponents_ui5_Select$events$() {
  if ((!$n_Lbe_doeraene_webcomponents_ui5_Select$events$)) {
    $n_Lbe_doeraene_webcomponents_ui5_Select$events$ = new $c_Lbe_doeraene_webcomponents_ui5_Select$events$();
  }
  return $n_Lbe_doeraene_webcomponents_ui5_Select$events$;
}
export { $m_Lbe_doeraene_webcomponents_ui5_Select$events$ as $m_Lbe_doeraene_webcomponents_ui5_Select$events$ };
